import { render, staticRenderFns } from "./MessageModal.vue?vue&type=template&id=700d6c15&scoped=true&"
import script from "./MessageModal.vue?vue&type=script&lang=ts&"
export * from "./MessageModal.vue?vue&type=script&lang=ts&"
import style0 from "./MessageModal.vue?vue&type=style&index=0&id=700d6c15&scoped=true&lang=scss&"
import style1 from "./MessageModal.vue?vue&type=style&index=1&id=700d6c15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700d6c15",
  null
  
)

export default component.exports